import * as React from 'react';
import ThirdPartyIntegrationAuthorization from './ThirdPartyIntegrationAuthorization';
import { bullhorn } from '../../../core/constants';

const BullhornAuthorization = () => {
	return <ThirdPartyIntegrationAuthorization integrationName={bullhorn} />;
};

export default BullhornAuthorization;
